import _defineProperty from "/home/seru/code/pr-site/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { visit } from 'unist-util-visit';
import { propertiesHandle, nextChild, prevChild, getCommentObject } from './utils.js';
var defaultOptions = {
  properties: 'data'
};

var rehypeAttrs = function rehypeAttrs(options) {
  var opts = _objectSpread(_objectSpread({}, defaultOptions), options);

  return function (tree) {
    visit(tree, 'element', function (node, index, parent) {
      if (node.tagName === 'pre' && node && Array.isArray(node.children) && parent && Array.isArray(parent.children) && parent.children.length > 1) {
        var firstChild = node.children[0];

        if (firstChild && firstChild.tagName === 'code' && typeof index === 'number') {
          var child = prevChild(parent.children, index);

          if (child) {
            var attr = getCommentObject(child);

            if (Object.keys(attr).length > 0) {
              node.properties = _objectSpread(_objectSpread({}, node.properties), {
                'data-type': 'rehyp'
              });
              firstChild.properties = propertiesHandle(firstChild.properties, attr, opts.properties);
            }
          }
        }
      }

      if (/^(em|strong|b|a|i|p|pre|kbd|blockquote|h(1|2|3|4|5|6)|code|table|img|del|ul|ol)$/.test(node.tagName) && parent && Array.isArray(parent.children) && typeof index === 'number') {
        var _child = nextChild(parent.children, index);

        if (_child) {
          var _attr = getCommentObject(_child);

          if (Object.keys(_attr).length > 0) {
            node.properties = propertiesHandle(node.properties, _attr, opts.properties);
          }
        }
      }
    });
  };
};

export default rehypeAttrs;